import React, {useState} from 'react'
import {withErrorHandling} from '../../hoc'
import {CardElement, Elements, injectStripe, StripeProvider} from 'react-stripe-elements'
import {Button, Form, Header, Message, Modal} from 'semantic-ui-react'
import {updatePaymentMethod} from '../../backend'

const createOptions = () => {
  return {
    style: {
      base: {
        fontSize: '16px',
        color: '#424770',
        fontFamily: 'Open Sans, sans-serif',
        letterSpacing: '0.025em',
        '::placeholder': {
          color: '#aab7c4',
        },
      },
      invalid: {
        color: '#c23d4b',
      },
    }
  }
}

let _UpdatePaymentMethod = (props) => {
  const {
    me,
    updatePaymentMethod,
    onClose
  } = props
  const cardElement = props.elements.getElement('card')

  const [state, setState] = useState({
    errorMessage: '',
    submitting: false
  })

  const onChange = ({error}) => {
    if (error) {
      setState({errorMessage: error.message})
    } else {
      if (state.errorMessage) {
        setState({...state, errorMessage: ''})
      }
    }
  }

  const onSubmit = async (e) => {
    e.preventDefault()
    setState({...state, submitting: true})
    const result = await props.stripe.createPaymentMethod({
      type: 'card',
      card: cardElement,
      billing_details: {
        email: me.email
      }
    })
    if (result.error) {
      setState({errorMessage: result.error.message, submitting: false})
      return
    }
    let subscription
    try {
      subscription = await updatePaymentMethod(result.paymentMethod.id)
      setState({...state, submitting: false})
      onClose(subscription)
    } catch (e) {
      setState({...state, errorMessage: e.data ? e.data.message : e.message, submitting: false})
      return
    }
  }

  return (
    <Modal open={true} closeOnDimmerClick={true} closeIcon={true} onClose={onClose} data-testid='update-card-modal'>
      <Modal.Content>
        <Header content='Card Details'/>
        <Form error={!!state.errorMessage} onSubmit={onSubmit}>
          <CardElement
            onChange={onChange}
            {...createOptions()}
          />
          {
            state.errorMessage && (
              <Message error data-testid='card-errors'>
                {state.errorMessage}
              </Message>
            )
          }
        </Form>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={onClose} data-testid='card-cancel-button'>Cancel</Button>
        <Button primary loading={state.submitting} onClick={onSubmit} data-testid='card-submit-button'>Submit</Button>
      </Modal.Actions>
    </Modal>
  )
}

_UpdatePaymentMethod = injectStripe(_UpdatePaymentMethod)

let UpdatePaymentMethod = (props) => {
  const {handleError} = props
  props = {...props, updatePaymentMethod: handleError(updatePaymentMethod)}
  return (
    <StripeProvider apiKey={process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY}>
      <Elements>
        <_UpdatePaymentMethod {...props}/>
      </Elements>
    </StripeProvider>
  )
}
UpdatePaymentMethod = withErrorHandling(UpdatePaymentMethod)


export {UpdatePaymentMethod, _UpdatePaymentMethod}

export default UpdatePaymentMethod